import { Clock, Flame } from "lucide-react";

const statusLabels = {
  payment_protected: "PAYMENT PROTECTED",
  delivery_reported: "BUYER REVIEW",
  disputed: "DISPUTED",
  released: "COMPLETE",
  refunded: "REFUNDED",
  no_sale: "NO SALE",
  buy_now_processing: "PROCESSING",
};

export const AuctionTimerCard = ({ auction, timerDisplay, timeRemaining }) => {
  const isUrgent = timerDisplay.urgent && timeRemaining > 0;
  return (
    <div
      className={`glass-card p-6 mb-4 ${isUrgent ? "border-[#EF4444]/50" : "border-[#D4AF37]/30"}`}
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          {isUrgent ? (
            <Flame className="w-5 h-5 text-[#EF4444] animate-pulse" />
          ) : (
            <Clock className="w-5 h-5 text-[#D4AF37]" />
          )}
          <span className="text-sm text-[#A1A1AA]">Time to Gavel</span>
        </div>
        <span
          className={`text-xs px-2 py-1 rounded ${
            auction.status === "active"
              ? "bg-[#22C55E]/10 text-[#22C55E]"
              : "bg-[#71717A]/10 text-[#71717A]"
          }`}
        >
          {auction.status === "active" ? "LIVE" : (statusLabels[auction.status] || auction.status.replaceAll("_", " ").toUpperCase())}
        </span>
      </div>

      <p
        className={`text-3xl font-bold text-center mb-2 ${
          isUrgent ? "text-[#EF4444]" : "text-[#EDEDED]"
        }`}
      >
        {timerDisplay.text}
      </p>

      {auction.extended_count > 0 && (
        <p className="text-xs text-center text-[#71717A]">
          Extended {auction.extended_count}x due to last-minute bids
        </p>
      )}
    </div>
  );
};
